// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"Breadcrumbs_breadcrumbs__10GE4"};